import { useCallback, useState } from 'react';

//* HOC's
import { withUserContext, withUIContext, withLanguageContext } from 'context';

//* Components
import Text from 'components/common/Text';
import Icon from 'components/common/Icon';
import Container from 'components/common/Container';
import FormContainer from 'components/common/FormContainer';
import FormItem from 'components/common/FormItem';
import FormInput from 'components/common/FormInput';
import Button from 'components/common/Button';
import LoginPopup from 'components/common/Popups/LoginPopup';

//* Style
import RegisterPopupStyle from './style';

const RegisterPopup = ({ register, popupProps, closePopup, openPopup, translate }) => {
	//! States
	const [isSend, setIsSend] = useState(false);
	const [isChecked, setIsChecked] = useState(false);

	const onFinish = useCallback(
		(values) => {
			if (isChecked) {
				setIsSend('loading');

				return register(values)
					.then(() => {
						popupProps.link && (window.location.href = popupProps.link);

						closePopup();

						return Promise.resolve();
					})
					.catch((err) => {
						setIsSend(false);

						return Promise.reject(err);
					});
			}
		},
		[isChecked]
	);

	//! Open Login popup
	const handleSignIn = useCallback(() => {
		openPopup(<LoginPopup />);
	}, [openPopup]);

	return (
		<>
			<RegisterPopupStyle />

			<Container
				full
				className='register-popup-cont'>
				<Text
					className={'h4 font-ping-medium popup-title'}
					text={'popupTitle'}
				/>
				<Text
					className={'pS font-ping-medium popup-subtitle'}
					text={'popupSubtitle'}
				/>
				<Text
					className={'pXS font-ping-regular popup-description'}
					text={'popupDescription'}
				/>
			</Container>

			<FormContainer onFinish={onFinish}>
				<Container
					full
					row
					className='register-popup-cont'>
					<FormItem
						name={'name'}
						className={'col-6 col-m-12 from-item'}>
						<FormInput placeholder={`${translate('name')}*`} />
					</FormItem>

					<FormItem
						name={'surname'}
						className={'col-6 col-m-12 from-item'}>
						<FormInput placeholder={`${translate('surname')}*`} />
					</FormItem>

					<FormItem
						name={'email'}
						validationType={'email'}
						className={'col-12 from-item'}>
						<FormInput placeholder={`${translate('email')}*`} />
					</FormItem>

					<FormItem
						validationType='password'
						name='password'
						className={'col-6 col-m-12 from-item'}>
						<FormInput
							type='password'
							placeholder={`${translate('password')}*`}
						/>
					</FormItem>

					<FormItem
						validationType='password'
						name='password_confirmation'
						className={'col-6 col-m-12 from-item'}>
						<FormInput
							type='password'
							placeholder={`${translate('confirmPassword')}*`}
						/>
					</FormItem>

					<FormItem
						name={'organization'}
						className={'col-6 col-m-12 from-item'}>
						<FormInput placeholder={`${translate('organization')}*`} />
					</FormItem>

					<FormItem
						name={'country'}
						className={'col-6 col-m-12 from-item'}>
						<FormInput placeholder={`${translate('country')}*`} />
					</FormItem>

					<FormItem
						name={'info'}
						className={'col-12 from-item'}
						required={false}>
						<FormInput placeholder={translate('registerPopupDesc')} />
					</FormItem>
				</Container>

				<Container
					full
					className='register-popup-cont'>
					<div
						className='checkbox-warp'
						onClick={() => setIsChecked(!isChecked)}>
						<div className={`checkbox ${isChecked ? 'active' : ''}`}>
							{isChecked && (
								<Icon
									name={'check'}
									className={'check-icon'}
								/>
							)}
						</div>

						<Text
							className={'pXS font-helvetica'}
							text={'termsText'}
						/>
					</div>

					<div className='register-buttons-wrap'>
						<Text
							className='pS sign-in colorBigStone underline font-ping-bolder'
							text={'login'}
							onClick={handleSignIn}
						/>

						<Button
							text={'register'}
							type={'icon-aside'}
							isBtnLoad={isSend === 'loading'}
							className={`register-btn ${isChecked || isSend ? '' : 'disabled-checked'} ${isSend ? 'disabled-checked' : ''}`}
						/>
					</div>
				</Container>
			</FormContainer>
		</>
	);
};

export default withLanguageContext(withUserContext(withUIContext(RegisterPopup, ['popupProps', 'closePopup', 'openPopup']), ['register']), ['translate']);
